import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import reducer from './store';
import { selectPendingTotal } from './store/dataSlice';
import { toggleNotificationPanel } from './store/stateSlice';

function NotificationPanelToggleButton(props) {
  const total = useSelector(selectPendingTotal);

  const dispatch = useDispatch();

  return (
    <IconButton
      className="w-30 h-30"
      onClick={(ev) => dispatch(toggleNotificationPanel())}
      size="small"
    >
      <Badge
        color="secondary"
        badgeContent={total}
        max={99}
        sx={{
          '& .MuiBadge-badge': {
            top: 4,
            right: -1,
            minWidth: 16,
            height: 16,
            padding: '0 4px',
            fontSize: 10,
          },
        }}
      >
        {props.children}
      </Badge>
    </IconButton>
  );
}

NotificationPanelToggleButton.defaultProps = {
  children: <FuseSvgIcon>heroicons-outline:bell</FuseSvgIcon>,
};

export default withReducer('notificationPanel', reducer)(NotificationPanelToggleButton);
